import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LineTagIcon from 'LuxKit/Icons/line/LineTagIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  standardInclusions: Array<App.PackageInclusion>
}

function CruiseStandardOnboardCreditLabel({ standardInclusions }: Props) {
  const onboardCredit = standardInclusions.find(({ parentCategory }) => parentCategory === 'ONBOARD_CREDIT')
  const highlightedInclusion = standardInclusions.find((inclusion) => inclusion.isHighlighted)

  const inclusionToDisplay = onboardCredit || highlightedInclusion || standardInclusions[0]

  const Icon = onboardCredit ? LineUsdCircleIcon : LineTagIcon

  return <>
    {!!inclusionToDisplay && <BodyTextBlock
      startIcon={<Icon colour="highlight-secondary" />}
      weight="bold"
      variant="medium"
      colour="highlight-secondary"
    >
      {inclusionToDisplay.description}
    </BodyTextBlock>}
  </>
}

export default CruiseStandardOnboardCreditLabel
